import CatalogCrud, { TextField, NumberField, ActiveToggleRow } from "./CatalogCrud";

const BLANK = {
  name: "",
  gitHub: {
    remoteName: "origin",
    apiBaseUrl: "https://api.github.com",
    owner: "",
    repositoryName: "",
    personalAccessToken: "",
    pageSize: 100,
  },
  isActive: true,
};

function snapshotFrom(item) {
  return {
    name: item.name ?? "",
    gitHub: {
      remoteName: item.gitHub?.remoteName ?? "origin",
      apiBaseUrl: item.gitHub?.apiBaseUrl ?? "https://api.github.com",
      owner: item.gitHub?.owner ?? "",
      repositoryName: item.gitHub?.repositoryName ?? "",
      personalAccessToken: item.gitHub?.personalAccessToken ?? "",
      pageSize: item.gitHub?.pageSize ?? 100,
    },
    isActive: !!item.isActive,
  };
}

function validate(snap) {
  if (!snap.name.trim()) return "Informe o nome.";
  if (!snap.gitHub.owner.trim()) return "Informe o owner do GitHub.";
  if (!snap.gitHub.repositoryName.trim()) return "Informe o nome do repositório.";
  return null;
}

export default function GitConfigList() {
  return (
    <CatalogCrud
      title="Git Configurations"
      description="Conexões com repositórios Git utilizadas pelos ambientes."
      endpoint="/admin/git-configurations"
      duplicateEnabled
      duplicateSuccessMsg="Configuração de Git duplicada com sucesso"
      itemSubtitle={(item) => {
        const parts = [item.gitHub?.owner, item.gitHub?.repositoryName].filter(Boolean);
        return parts.length ? parts.join(" / ") : null;
      }}
      blank={BLANK}
      snapshotFrom={snapshotFrom}
      validate={validate}
      renderForm={({ form, update, saving }) => (
        <>
          <TextField
            label="Nome"
            value={form.name}
            onChange={(v) => update("name", v)}
            placeholder="Ex: Qualitycert GitHub"
            disabled={saving}
            required
          />

          <div className="pt-3 border-t border-slate-100">
            <h3 className="text-sm font-bold text-slate-800 mb-0.5">GitHub</h3>
            <p className="text-xs text-slate-500 mb-3">Credenciais e metadados usados pela API do GitHub.</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <TextField
                label="Remote name"
                value={form.gitHub.remoteName}
                onChange={(v) => update("gitHub.remoteName", v)}
                placeholder="origin"
                disabled={saving}
              />
              <TextField
                label="API base URL"
                value={form.gitHub.apiBaseUrl}
                onChange={(v) => update("gitHub.apiBaseUrl", v)}
                placeholder="https://api.github.com"
                disabled={saving}
              />
              <TextField
                label="Owner"
                value={form.gitHub.owner}
                onChange={(v) => update("gitHub.owner", v)}
                placeholder="fabiosms"
                disabled={saving}
                required
              />
              <TextField
                label="Repository"
                value={form.gitHub.repositoryName}
                onChange={(v) => update("gitHub.repositoryName", v)}
                placeholder="Qualitycert"
                disabled={saving}
                required
              />
              <div className="sm:col-span-2">
                <TextField
                  label="Personal access token"
                  value={form.gitHub.personalAccessToken}
                  onChange={(v) => update("gitHub.personalAccessToken", v)}
                  placeholder="ghp_…"
                  type="password"
                  mono
                  disabled={saving}
                  helper="Armazenado de forma segura no backend."
                />
              </div>
              <NumberField
                label="Page size"
                value={form.gitHub.pageSize}
                onChange={(v) => update("gitHub.pageSize", v)}
                min={1}
                disabled={saving}
              />
            </div>
          </div>

          <ActiveToggleRow
            checked={form.isActive}
            onChange={(v) => update("isActive", v)}
            disabled={saving}
            label="Configuração ativa"
            description="Desative para excluir esta configuração da seleção em novos ambientes."
          />
        </>
      )}
    />
  );
}
